/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-03-25 13:33:09
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */
import apiFile from '@/api/api-file'
export default {
    // name:'UploadImgs',
    data(){
        return {
            // fileList:[],
            // baseUrl: '',
            // uploadFileList:[],
            // removeFileList:[],
            // //需要处理图片的名称与类型
            // headerImage:null,
            // files:{
            //     name:'',
            //     type:'',
            // },
            //需要处理图片的base64
            // picValue:null,
            baseFileUrl: this.$config.baseFileUrl,
            fileDict: {}
        }
    },
    props:{
        value: Array,
        maxCount:{
            type:Number,
            default: 1
        },
        capture:{
            type:String,
            default:'camera'
        },
        disabled:{
            type:Boolean,
            default: false
        },
        multiple:{
            type:Boolean,
            default: false
        },
        maxSize:{
            type:Number,
            default: 10485760 // 10MB
        }
    },
    methods:{
        beforeDelete(file, detail){
            if(!this.value) return true
            let fileList = this.value.concat()
            fileList.splice(detail.index, 1)
            if(!fileList) fileList = []
            this.$emit('input', fileList)
            return true
        },
        // //图片格式处理--与后端vm对应
        // FilesHandler(){
        //     //处理前，先清空一遍
        //     this.uploadFileList = [];
        //     this.fileList.forEach((file)=>{
        //         if(file.content!=undefined){
        //             let image = {base64:file.content,filename:file.file.name,type:file.file.type,size:file.file.size};
        //             this.uploadFileList.push(image);
        //         }else{
        //             this.uploadFileList.push(file);
        //         }
        //     })
        //     return true;
        // },
        afterRead() {
        },
        beforeRead(file){
            let fileList = this.value? this.value: []
            if(fileList.length > this.maxCount){
                this.$alert.toast(`最多只能上传${this.maxCount}张图片!`, '')
                return false
            }
            if(file.size > this.maxSize){
                this.$alert.toast(`上传的照片大小不能超过10MB!`, '')
                return false
            }
            let result = this.getFileByName(file.name)
            console.log(result)
            if(result) {
                if(this.multiple) {
                    fileList.push(result)
                }
                else
                {
                    fileList = [result]
                }
                this.$emit('input', fileList)
            }
            else {
                apiFile.uploadClient.upload(file).then(res=> {
                    let status = 'uploading' // 上传完成
                    let url = '上传中...'
                    let message = ''
                    if(res && res.success) {
                        status = 'done'
                        url = res.message
                    }
                    else{
                        status = 'failed'
                        message = '上传失败'
                    }
                    let fileOptions = { url: this.baseFileUrl + '/' + url, path: url, status: status, message: message }
                    this.setCache(file.name, fileOptions) // 设置临时缓存
                    if(this.multiple) {
                        fileList.push(fileOptions)
                    }
                    else
                    {
                        fileList = [fileOptions]
                    }
                    this.$emit('input', fileList)
                })
            }
            //     // this.imgPreview(this.picValue);
        },
        setCache(fileName, file) {
            this.$set(this.fileDict, fileName, file)
        },
        // 处理图片
        imgPreview(file) {
            let _this = this;
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/\/(?:jpeg|png)/i.test(file.type)) {
                // 创建一个reader
                let reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = function () {
                    let result = this.result;
                    let img = new Image();
                    img.src = result;
                    console.log("处理图片")
                    console.log(img)
                    console.log(_this.picValue)
                    //判断图片是否大于200K,是就直接上传，反之压缩图片
                    if (this.result.length <= 200 * 1024) {
                        // _this.fileList.push(_this.picValue);
                    } 
                    else {
                        img.onload = function () {
                            _this.compress(img);
                        };
                    }
                };
            }
        },
        // 压缩图片
        compress(img) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            //瓦片canvas
            let tCanvas = document.createElement("canvas");
            let tctx = tCanvas.getContext("2d");
            // let initSize = img.src.length;
            let width = img.width;
            let height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至100万以下
            let ratio;
            if ((ratio = (width * height) / 1000000) > 1) {
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //    铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            let count;
            if ((count = (width * height) / 1000000) > 1) {
                // console.log("超过100W像素");
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                // 计算每块瓦片的宽和高
                let nw = ~~(width / count);
                let nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (let i = 0; i < count; i++) {
                for (let j = 0; j < count; j++) {
                    tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                    ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                } 
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //进行适当压缩
            let ndata = canvas.toDataURL("image/jpeg", 0.2);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            var blob = this.dataURLtoFile(ndata);
            let File = {file:blob,content:ndata}
            this.fileList.push(File)
        },
        //将base64转换为文件
        dataURLtoFile(dataurl) {
            var arr = dataurl.split(","),
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], this.files.name, {
                type: this.files.type
            });
        },
    },
    computed: {
        getFileByName() {
            return function(fileName) {
                return this.fileDict[fileName]
            }
        },
    }
}